/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "customers-management",
	data() {
		return {
			customers: [],
			genders: [],
			gendersFilter: [],
			customerHeadings: [
				{
					text: "First Name",
					field: "firstName"
				},
				{
					text: "Last Name",
					field: "lastName"
				},
				{
					text: "DateOfBrith",
					field: "dateOfBirthString"
				},
				{
					text: "Gender",
					field: "gender"
				},
				// {
				// 	text: "Residential Address",
				// 	field: "residentialAddress"
				// },
				{
					text: "Email Address",
					field: "emailAddress"
				},
				{
					text: "Mobile Number",
					field: "cellNumberLocal"
				},
				{
					text: "Is Customer Active?",
					field: "isActive"
				},
				{
					text: "Last Updated By",
					field: "lastUpdatedOnString"
				},
				{
					text: "Date Of Last Transaction",
					field: "lastTransactionDateString"
				},
				{
					text: "Date Created",
					field: "insertedOnString"
				},
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			actions: [],
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive",
				deactivateCard: "deactivateCard",
				viewTransactions: "viewTransactions",
				issueNewCard: "issueNewCard"
			},
			customerAddEditFormModal:{
				showModal: false,
				isSaving: false,
				modalId: "addEditCustomerModal",
				heading: "Add Customer"
			},
			customerMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markAsActiveInactiveCustomerModal",
				heading: "Mark Customer As Active/Inactive",
				isActive: null,
				personId: null
			},
			deactivateCardModal:{
				showModal: false,
				isSaving: false,
				modalId: "deactivateCardModal",
				heading: "Deactivate Card",
				message: "Are you want to deactivate the customer's card?",
				personId: null,
				cardId: null,
				cardBarcode: null,
				personCardId: null
			},
			customer:{
				personId: null,
				cardBarcodeNumber: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				firstName: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				lastName: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				emailAddress: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				mobileNumber: {
					value: "27",
					hasError: false,
					errorMessage: null
				},
				dateOfBirth: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				gender: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				placeOfResidence:{
					street: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					suburb: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					city: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					province: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					postalCode: {
						value: null,
						hasError: false,
						errorMessage: null
					}
				}
			},
			issueNewCardModal:{
				showModal: false,
				isSaving: false,
				modalId: "issueNewCardModal",
				heading: "Issue New Card",
				cardBarcodeNumber: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				customerId: null
			},
			filterStateChanged: false,
			filter:{
				fromDateCreated: null,
				toDateCreated: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1,
				gender: null,
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null,
			initialiseActiveFromDate: true,
		};
	},
	methods: {
		getCustomers(){
			this.loading = true;
			let request = {
				searchQuery: this.filter.customerSearchQuery,
				isActive: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
				dateCreatedFrom: this.filter.fromDateCreated === null ? null : moment(this.filter.fromDateCreated).format("DD/MM/YYYY"),
				dateCreatedTo: this.filter.toDateCreated === null ? null : moment(this.filter.toDateCreated).format("DD/MM/YYYY"),
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize,
				genderId: this.filter.gender === -1 ? null : this.filter.gender
			};
			customerService.getCustomerPeople(request).then(response => {
				console.log("response", response);
				if(response.status === 200){
					this.customers = response.data.result;
					this.pagingDetails.pageNumber = response.data.pagingInfo.thisPage;
					this.pagingDetails.totalPages = response.data.pagingInfo.totalPages;
					for (let i = 0; i < this.customers.length; i++) {
						this.customers[i].actions = [
							{
								name: "Edit",
								key: this.actionKeys.edit,
								elementId: "btnEditCustomer"
							},
							{
								name: this.customers[i].isActive ? "Mark As Inactive" : "Mark As Active",
								key: this.actionKeys.markAsActiveInactive,
								elementId: "btnCustomerMarkAsActiveInactive"
							},
							// {
							// 	name: "Issue New Card",
							// 	key: this.actionKeys.issueNewCard,
							// 	elementId: "btnCustomerIssueNewCard"
							// },
							// {
							// 	name: "Deactivate Card",
							// 	key: this.actionKeys.deactivateCard,
							// 	elementId: "btnCustomerDeactivateCard"
							// },
							{
								name: "View Transactions",
								key: this.actionKeys.viewTransactions,
								elementId: "btnCustomerViewTransactions"
							}
						];
						if(this.customers[i].personCardId !== null && this.customers[i].personCardId > 0){
							this.customers[i].actions.push(
								{
									name: "Deactivate Card",
									key: this.actionKeys.deactivateCard,
									elementId: "btnCustomerDeactivateCard"
								}
							);
						}
						else{
							this.customers[i].actions.push(
								{
									name: "Issue New Card",
									key: this.actionKeys.issueNewCard,
									elementId: "btnCustomerIssueNewCard"
								}
							);
						}
					}
					this.filterStateChanged = false;
					this.customers = dataTableHelper.castFieldValues(this.customers);
				}
				this.loading = false;
			});
		},
		getGenders(){
			systemService.getGenders().then(response => {
				if(response.status === 200) {
					this.genders = response.data.result;
					this.gendersFilter = response.data.result;
					this.genders = $.map(this.genders,
						function (obj) {
							obj.id = obj.id || obj.genderId;
							obj.text = obj.text || obj.description;
							return obj;
						});
					this.gendersFilter = $.map(this.gendersFilter,
						function (obj) {
							obj.id = obj.id || obj.genderId;
							obj.text = obj.text || obj.description;
							return obj;
						});
					this.gendersFilter.unshift({
						id: -1,
						text: "All"
					});
				}
			});
		},
		onExportToCsvClick(){
			let request = {
				searchQuery: this.filter.customerSearchQuery,
				isActive: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
				dateCreatedFrom: this.filter.fromDateCreated === null ? null : moment(this.filter.fromDateCreated).format("DD/MM/YYYY"),
				dateCreatedTo: this.filter.toDateCreated === null ? null : moment(this.filter.toDateCreated).format("DD/MM/YYYY"),
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize,
				genderId: this.filter.gender === -1 ? null : this.filter.gender
			};
			customerService.exportCustomersAsCsv(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					const url = window.URL.createObjectURL(new Blob([successResponse.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', 'file.csv');
					document.body.appendChild(link);
					link.click();
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onGenderFilterSelect(gender){
			if(this.filter.gender !== gender.id) {
				this.filterStateChanged = true;
				this.filter.gender = gender.id;
			}
			
			// if(transactionType.id === 0){
			// 	this.filter.selectedTransactionTypeId = null;
			// }
			// else{
			// 	this.filter.selectedTransactionTypeId = transactionType.id;
			// }
		},
		onFilterSearchClicked(){
			this.pagingDetails.pageNumber = 1;
			this.pagingDetails.totalPages = 1;
			this.getCustomers();
		},
		onDateFilterClearClick(){
			console.log("clear clicked");
			this.filter.toDateCreated = null;
			this.filter.fromDateCreated = null;
			this.filterStateChanged = true;
		},
		onToDateCreatedSelect(date){
			this.filter.toDateCreated = date;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onFromDateCreatedSelect(date){
			this.filter.fromDateCreated = date;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onPagingUpdated(pagingInfo){
			console.log("pagingInfo", pagingInfo)
			this.pagingDetails.pageNumber = pagingInfo.pageNumber;
			this.getCustomers();
		},
		onCustomerActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.edit:
					this.customerAddEditFormModal.showModal = true;
					this.customerAddEditFormModal.heading = "Edit Customer";
					this.customer.cardBarcodeNumber.value = actionAndData.data.cardBarcode;
					this.customer.firstName.value = actionAndData.data.firstName;
					this.customer.lastName.value = actionAndData.data.lastName;
					this.customer.emailAddress.value = actionAndData.data.emailAddress;
					this.customer.mobileNumber.value = actionAndData.data.cellNumber;
					this.customer.placeOfResidence.street.value = actionAndData.data.residentialStreetAddress;
					this.customer.placeOfResidence.suburb.value = actionAndData.data.residentialSuburb;
					this.customer.placeOfResidence.city.value = actionAndData.data.residentialCity;
					this.customer.placeOfResidence.province.value = actionAndData.data.residentialProvince;
					this.customer.placeOfResidence.postalCode.value = actionAndData.data.residentialPostalCode;
					this.customer.gender.value = actionAndData.data.genderId;
					this.customer.personId = actionAndData.data.personId;
					var self = this;
					setTimeout(() => {
						self.customer.dateOfBirth.value = actionAndData.data.dateOfBirth;
						console.log("actionAndData.data.dateOfBirth", actionAndData.data.dateOfBirth);
					}, 500);
					break;
				case this.actionKeys.markAsActiveInactive:
					this.customerMarkAsActiveInactiveModal.showModal = true;
					this.customerMarkAsActiveInactiveModal.personId = actionAndData.data.personId;
					this.customerMarkAsActiveInactiveModal.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					this.customerMarkAsActiveInactiveModal.heading = "Mark Customer As " + (this.customerMarkAsActiveInactiveModal.isActive ? "Inactive - " : "Active - ") + actionAndData.data.firstName + " " + actionAndData.data.lastName;
					break;
				case this.actionKeys.issueNewCard:
					this.issueNewCardModal.showModal = true;
					this.issueNewCardModal.customerId = actionAndData.data.personId;
					break;
				case this.actionKeys.deactivateCard:
					this.deactivateCardModal.showModal = true;
					this.deactivateCardModal.personId = actionAndData.data.personId;
					this.deactivateCardModal.cardId = actionAndData.data.cardId;
					this.deactivateCardModal.cardBarcode = actionAndData.data.cardBarcode;
					this.deactivateCardModal.personCardId = actionAndData.data.personCardId;
					break;
				case this.actionKeys.viewTransactions:
					this.$router.push("/customers/transactions/" + actionAndData.data.personId);
					break;
			}
		},
		onMobileNumberInput(){
			console.log("length", this.customer.mobileNumber.value.length)
			if(this.customer.mobileNumber.value === null || this.customer.mobileNumber.value === ""){
				this.customer.mobileNumber.value = "27";
			}
			else if(this.customer.mobileNumber.value.length < 2){
				this.customer.mobileNumber.value = "27";
			}
		},
		onMarkUserActiveInactiveSelected(isActive){
			this.customerMarkAsActiveInactiveModal.isActive = isActive;
			console.log("customerMarkAsActiveInactiveModal.isActive", this.customerMarkAsActiveInactiveModal.isActive);
			
		},
		onMarkAsActiveInactiveSaveClick(markAsActive){
			this.customerMarkAsActiveInactiveModal.isSaving = true;
			let request = {
				personId: this.customerMarkAsActiveInactiveModal.personId,
				isActive: markAsActive
			};
			customerService.markCustomerPersonAsActiveOrInActive(request).then(response => {
				if(response.status === 200){
					this.getCustomers();
					this.customerMarkAsActiveInactiveModal.showModal = false;
					this.customerMarkAsActiveInactiveModal.personId = null;
					this.customerMarkAsActiveInactiveModal.isActive = null;
				}
				this.customerMarkAsActiveInactiveModal.isSaving = false;
			});
		},
		onDateOfBirthSelect(date){
			this.customer.dateOfBirth.value = date;
			console.log("dateOfBirth", this.customer.dateOfBirth.value)
			this.initialiseActiveFromDate = false;
		},
		onGenderSelect(id){
			this.customer.gender.value = id.id;
		},
		onEditCustomerModalCloseClick(){
			this.customerAddEditFormModal.showModal = false;
			this.clearCustomerModel();
		},
		onIssueNewCardModalCloseClick(){
			this.issueNewCardModal.showModal = false;
			this.issueNewCardModal.cardBarcodeNumber.value = null;
		},
		onIssueNewCardModalSaveClick() {
			this.issueNewCardModal.isSaving = true;
			let request = {
				personId: this.issueNewCardModal.customerId,
				cardBarcode: this.issueNewCardModal.cardBarcodeNumber.value
			};
			customerService.issueNewCardToCustomerPerson(request).then(
				response => {
					if(response.status === 400){
						//show validation errors
						this.issueNewCardModal.cardBarcodeNumber.errorMessage = response.data.cardNumberValidationResponse.message;
						this.issueNewCardModal.cardBarcodeNumber.hasError = response.data.cardNumberValidationResponse.hasError;
					}
					if(response.status === 200){
						this.getCustomers();
						this.issueNewCardModal.showModal = false;
						this.issueNewCardModal.cardBarcodeNumber.value = null;
					}
					this.issueNewCardModal.isSaving = false;
				}
			);
		},
		onActionConfirmed(isConfirmed) {
			if (isConfirmed) {
				this.deactivateCardModal.isSaving = true;
				let request = {
					personId: this.deactivateCardModal.personId,
					cardId: this.deactivateCardModal.cardId,
					personCardId: this.deactivateCardModal.personCardId
				};
				customerService.deactivateCustomerPersonCard(request).then(
					response => {
						if(response.status === 200){
							this.getCustomers();
							this.deactivateCardModal.showModal = false;
							this.deactivateCardModal.personId = null;
							this.deactivateCardModal.cardId = null;
							this.deactivateCardModal.cardBarcode = null;
							this.deactivateCardModal.personCardId = null;
						}
						this.deactivateCardModal.isSaving = false;
					}
				);
			}
			else{
				this.deactivateCardModal.showModal = false;
			}
		},
		clearCustomerModel(){
			this.customer = {
				personId: null,
				cardBarcodeNumber: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				firstName: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				lastName: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				emailAddress: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				mobileNumber: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				dateOfBirth: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				gender: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				placeOfResidence:{
					street: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					suburb: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					city: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					province: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					postalCode: {
						value: null,
						hasError: false,
						errorMessage: null
					}
				}
			};
		},
		onEditCustomerModalSaveClick(){
			//save
			this.customerAddEditFormModal.isSaving = true;
			let request = {
				cardBarcodeNumber: this.customer.cardBarcodeNumber.value,
				firstName: this.customer.firstName.value,
				lastName: this.customer.lastName.value,
				emailAddress: this.customer.emailAddress.value,
				cellNumber: this.customer.mobileNumber.value,
				dateOfBirth: this.customer.dateOfBirth.value === null ? null : moment(this.customer.dateOfBirth.value).format("DD/MM/YYYY"),
				streetAddress: this.customer.placeOfResidence.street.value,
				suburb: this.customer.placeOfResidence.suburb.value,
				city: this.customer.placeOfResidence.city.value,
				province: this.customer.placeOfResidence.province.value,
				postalCode: this.customer.placeOfResidence.postalCode.value,
				gender: this.customer.gender.value,
				personId: this.customer.personId
			};
			customerService.updateCustomerPerson(request).then(
				response => {
					if(response.status === 400){
						//show validation errors
						this.customer.cardBarcodeNumber.errorMessage = response.data.customerValidationResponse.cardNumberValidationResponse.message;
						this.customer.cardBarcodeNumber.hasError = response.data.customerValidationResponse.cardNumberValidationResponse.hasError;

						this.customer.firstName.errorMessage = response.data.customerValidationResponse.firstNameValidationResponse.message;
						this.customer.firstName.hasError = response.data.customerValidationResponse.firstNameValidationResponse.hasError;
						
						this.customer.lastName.errorMessage = response.data.customerValidationResponse.lastNameValidationResponse.message;
						this.customer.lastName.hasError = response.data.customerValidationResponse.lastNameValidationResponse.hasError;

						this.customer.mobileNumber.errorMessage = response.data.customerValidationResponse.phoneNumberValidationResponse.message;
						this.customer.mobileNumber.hasError = response.data.customerValidationResponse.phoneNumberValidationResponse.hasError;
						
						this.customer.emailAddress.errorMessage = response.data.customerValidationResponse.emailValidationResponse.message;
						this.customer.emailAddress.hasError = response.data.customerValidationResponse.emailValidationResponse.hasError;

						if(response.data.validationResult !== null){
							if(response.data.validationResult.cellNumberDoesNotExist === false){
								this.customer.mobileNumber.errorMessage = "Cell number already exists. It's in use by another customer.";
								this.customer.mobileNumber.hasError = true;
							}

							if(response.data.validationResult.emailDoesNotExist === false){
								this.customer.emailAddress.errorMessage = "Email already exists. It's in use by another customer.";
								this.customer.emailAddress.hasError = true;
							}
						}
						
					}
					if(response.status === 200){
						this.getCustomers();
						this.customerAddEditFormModal.showModal = false;
						this.clearCustomerModel();
					}
					this.customerAddEditFormModal.isSaving = false;
				}
			);
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Customers");
			breadcrumbsStoreState.setRootBreadcrumb(this.$route.path, "Customers");
		}
	},
	mounted: function () {
		var self = this;
		setTimeout(() => {
			self.filter.gender = -1;
		}, 500);
		
		console.log('this.filter.gender', this.filter.gender)
		this.setBreadcrumbs();
		this.getCustomers();
		this.getGenders();
	}
};